import Footer from "./parts/footer"
import HeaderInternal from "./parts/header-internal"

function Congratulations() {
    return (
        <>
            <HeaderInternal />
            <div className="container w-full max-w-screen-sm m-auto my-16">
                <article>
                    <h1>Ваша реєстрація на GET Business Festival 2027 пройшла успішно!</h1>
                    
                    <p>
                        Дякуємо, що долучаєтесь до простору для підприємців, управлінців, лідерів, новаторів та всіх, хто прагне розвивати бізнес і створювати майбутнє України.
                    </p>
                    
                    <p>
                        Ваша участь у фестивалі від <a className="text-blue-500 underline font-bold" href="https://Dilo.ua">Dilo.ua</a> є надзвичайно важливою для нас. Ми цінуємо вашу довіру та готовність стати частиною спільноти людей, які обмінюються досвідом, надихають одне одного та разом формують нові можливості для розвитку.
                    </p>
                    
                    <p>
                        Реєстрація на GET наразі є попередньою. Ближче до дати проведення ми надішлемо вам нагадування про захід з організаційною інформацією, а також попросимо підтвердити свою участь. 
                    </p>
                    
                    <p>
                        <b>Дякуємо, що ви з нами!</b>
                    </p>
                </article>
            </div>
            <Footer />
        </>

    )
}

export default Congratulations;